import React, { useState, useEffect } from "react";
import EditBill from "../../../../../entities/DashboardPage/AccountingModule/Supplier/EditBill";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useNavigate, useLocation } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";

const EditBillPage = () => {
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [supplierList, setSupplierList] = useState();
  const [loading, setLoading] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [oneBillData, setOneBillData] = useState();
  const { state } = useLocation();
  const { item } = state || {};

  useEffect(() => {
    getItem();
    getSupplierList();
  }, []);

  const getSupplierList = async (text, sort, page) => {
    setLoading(true);
    try {
      const result = await AuthService.getSupplier(text, sort, page);
      if (result?.success) {
        setSupplierList(result?.data?.suppliers);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getItem = async (text) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getItemsList(text);
      if (result?.success) {
        setItemList(result?.data?.items);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const updateBill = async (payload) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.updateBill(payload, item?._id);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/supplierDetails")
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
    }
  };

  const getOneBillHandler = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getOneBill(id);
      if (result?.success) {
        setOneBillData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  return (
    <EditBill updateBillHandler={updateBill} item={item} loading={loading} handleItemList={getItem} itemList={itemList} supplierList={supplierList} handleSupplierList={getSupplierList} getOneBillHandler={getOneBillHandler} oneBillData={oneBillData} />
  )

}

export default EditBillPage;
